/**
 * In-memory LRU of decrypted message threads.
 * Survives MessagesPage remount so reopening a conversation paints immediately.
 */

const MAX_CONV_CACHE = 12;

let cache = new Map();
let lru = [];
let ownerUserId = undefined;
const inFlight = new Map();

export function getCachedThread(conversationId) {
  if (conversationId == null) return null;
  return cache.get(conversationId) || null;
}

export function setCachedThread(conversationId, entry) {
  if (conversationId == null || !entry) return;
  cache.set(conversationId, entry);
  touchThreadCache(conversationId);
}

export function touchThreadCache(conversationId) {
  lru = lru.filter((id) => id !== conversationId);
  lru.unshift(conversationId);
  if (lru.length > MAX_CONV_CACHE) {
    const evict = lru.pop();
    cache.delete(evict);
  }
}

export function bindMessageThreadCacheUser(userId) {
  if (ownerUserId === undefined) {
    ownerUserId = userId;
    return false;
  }
  if (ownerUserId === userId) return false;
  ownerUserId = userId;
  cache = new Map();
  lru = [];
  inFlight.clear();
  return true;
}

export function getInFlightThreadLoad(conversationId) {
  return inFlight.get(conversationId) || null;
}

export function setInFlightThreadLoad(conversationId, promise) {
  inFlight.set(conversationId, promise);
}

export function clearInFlightThreadLoad(conversationId) {
  inFlight.delete(conversationId);
}

export function clearMessageThreadCache() {
  cache = new Map();
  lru = [];
  ownerUserId = undefined;
  inFlight.clear();
}

export function cachedThreadCount() {
  return cache.size;
}
